<dx-popup
  [width]="600"
  [(visible)]="showModal"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'SUBSCRIPTIONS.REJECT-REQUEST.TITLE' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  (onHidden)="close()"
>
  <div *dxTemplate="let data of 'content'">
    <dx-form
      #declineForm
      [formData]="formData"  
    >
      <dxi-item 
        dataField="reason"  
        editorType="dxTextArea"
        [label]="{ 
          visible: false 
        }"
        [editorOptions]="{ 
          height: 200,
          placeholder: ('SUBSCRIPTIONS.REJECT-REQUEST.ADD-YOUR-MESSAGE' | translate)
        }"
      >
        <dxi-validation-rule
          type="required"
          [message]="'SUBSCRIPTIONS.REJECT-REQUEST.DECLINE-REASON-REQUIRED' | translate"
        >
        </dxi-validation-rule>
      </dxi-item>

      <dxi-item>
        <div *dxTemplate>
          <div class="button-container">
            <dx-button 
              [text]="'COMMON.BACK' | translate" 
              type="danger"
              stylingMode="contained"
              (onClick)="close()"
            ></dx-button>
            <dx-button 
               [text]="'COMMON.SEND' | translate" 
              type="normal"
              stylingMode="contained"
              (onClick)="onSendClick()"
            ></dx-button>
          </div>
        </div>
      </dxi-item>
    </dx-form>
  </div>
</dx-popup>